import React from "react";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';

import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import { Link } from "react-router-dom";
import SettingsIcon from '@mui/icons-material/Settings';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Style from "../../../styles/js/Styles.js";

import residuesService from "../../../plas/services/residues/service";

export default function MapMenu( { open, onExpand } ) {

  const style = Style();

  const [expanded, setExpanded] = React.useState(false);
  
  React.useEffect(() => {
    if (!open) {
      setExpanded(false);
    }
  }, [open]);

  const onClick = () => {
    if (!expanded) {
      onExpand();
    }
    setExpanded(!expanded);
  }
  
  return (
    <div>
     { (residuesService.canAdmin()) ? (
        <div>
          <ListItem button onClick={onClick}>
            <ListItemIcon>
              <RestoreFromTrashIcon />
            </ListItemIcon>
            <ListItemText className={style.menuTextItem} primary="Residuos" />
            { expanded && open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={expanded && open} timeout="auto" unmountOnExit style={{paddingLeft:"24px"}}>
            <List component="div">
              <div>
                { residuesService.canAdmin() && (
                  <>
                    <ListItem button component={Link} to={"/residues/appointments"} >
                      <ListItemIcon>
                        <CalendarMonthIcon/>
                      </ListItemIcon>
                      <ListItemText className={style.menuTextItem} primary="Turnos" />
                    </ListItem>
                    <ListItem button component={Link} to={"/residues/settings"} >
                      <ListItemIcon>
                        <SettingsIcon/>
                      </ListItemIcon>
                      <ListItemText className={style.menuTextItem} primary="Ajustes" />
                    </ListItem>
                  </>
                )}
              </div>
            </List>
          </Collapse>
        </div>) : (null) 
     }
    </div>
    
  );
}
